
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offences/[offence]",
      function () {
        return require("private-next-pages/offences/[offence].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offences/[offence]"])
      });
    }
  